
var language = {
  // 中文
  1: {
    // 顶部内容
    top: {
      // 导航
      navs: [
        {path: "index",name: "首页"},
        {path: "product",name: "产品技术", other: {key: "MimicPro 2"},children: [
          {path: "product",name: "EDA", other: {key: "MimicPro 2"}, children: [
            {path: "product",name: "MimicTurbo GT", other: {key: "MimicTurbo GT"}},
            {path: "product",name: "MimicPro 2", other: {key: "MimicPro 2"}},
            {path: "product",name: "MimicPro 3", other: {key: "MimicPro 3"}},
          ]},
          {path: "product",name: "IP", other: {key: "USB"}, children: [
            {path: "product",name: "USB 控制器", other: {key: "USB"}},
            {path: "product",name: "PCle 控制器", other: {key: "PCle"}},
            {path: "product",name: "RDMA", other: {key: "RDMA"}}
          ]}
        ]},
        {path: "service",name: "支持与服务",children: []},
        {path: "news",name: "新闻中心",children: []},
        {path: "about",name: "关于我们",children: [{
          path: "about",name: "公司简介", other: {key: "content"}, children: []
        },{
          path: "about",name: "发展历程", other: {key: "development"}, children: []
        },{
          path: "about",name: "投资伙伴", other: {key: "partner"}, children: []
        },{
          path: "zhao",name: "加入我们", other: {}, children: []
        }]},
      ],
    },
    // 底部内容
    foot: {
      // 导航
      navs: [
        {path: "index",name: "首页"},
        {path: "product",name: "产品技术", other: {key: "MimicPro 2"},children: [{path: "productList",name: "EDA", other: {key: "EDA"}},{path: "productList",name: "IP", other: {key: "IP"}}]},
        {path: "service",name: "支持与服务",children: [{path: "service",name: "线上技术支持", other: {key: 'zhichi'}},{path: "service",name: "文档中心", other: {key: 'ziliao'}},{path: "service",name: "技术视频", other: {key: 'videos'}}]},
        {path: "news",name: "新闻中心",children: [{path: "news",name: "公司动态"},{path: "news",name: "媒体关注"}]},
        {path: "about",name: "关于我们",children: [{path: "about",name: "公司简介", other: {key: "content"}},{path: "about",name: "发展历程", other: {key: "development"}},{path: "zhao",name: "加入我们"}]},
      ],
      // 地址
      addr: "江苏省南京市溧水区东屏街道开屏路11号",
    },
    // 首页
    index: {
      // 公司描述
      describe: [
        "云海金属集团成立于1993年，2007年在深交所上市。",
        "公司经过二十多年的发展，成为了一家集矿业开采、有色金属冶炼和回收加工为一体的高新技术企业。",
        "集团在全国设有10余家子公司，产品广泛应用于交通工具、3C电子及航空航天等领域。"
      ],
      // 按钮
      btn1: "关于我们",
      btn2: "媒体中心",
      btn3: "产品中心",
    },
    // 关于我们
    about: {
      lists: {title: "关于我们",child: [{name: "公司介绍"},{name: "发展历程"},{name: "公司分布"},{name: "研发平台"}]},
      title: "云海金属",
      title2: "全球轻金属材料领域领军者",
      describe: [
        "云海金属集团成立于1993年，2007年在深交所上市。公司经过三十年的发展，成为了一家集矿业开采、有色金属冶炼、加工与回收为一体的高新技术企业。集团在全球设有10余家子公司，产品广泛应用于汽车工业、3C电子及航空航天等领域。",
        "作为全球轻金属材料领域的领军者，云海金属拥有完整的产品研发与制造能力，镁、铝、锶等主要产品的市场份额全球领先。近年来，集团公司凭借原材料领域的深厚积累，积极向下游轻量化零部件领域拓展，形成了“白云石开采-原镁冶炼-镁合金熔炼-镁合金加工-镁合金回收”完整镁产业链以及“高性能铝合金-铝挤压加工”特色产品系。",
        "面向未来，云海金属坚持创新，坚持国际化，坚持绿色与可持续发展，致力于打造“高技术效益型轻量化产业集团”，为中国乃至全球轻量化工业发展提供优质的产品和服务。",
      ],
      title3: "发展历程",
      title4: "二十多年不断积累探索",
      title5: "公司分布",
      title6: "全国及海外10余家子公司",
      title7: "研发平台",
      more: "加载更多···",
      all: "全部内容加载完毕",
      desc: "简介",
      addr: "地址",
      phone: "电话",
      zong: "总公司",
      fen1: "全资子公司",
      fen2: "合资公司",
      dataList: [
        {right: 198,top: 220,name: "五台",nameAll: "五台云海镁业有限公司",desc: "云海金属集团全资子公司，主要生产镁合金、金属锶。",
        addr: "山西省忻州市五台县工业园",phone: "0350-3357550"},
        {right: 155,top: 250,name: "聊城",nameAll: "山东云信铝业科技有限公司",desc: "云海金属集团与信发集团有限公司共同合资成立，主要经营范围包括铝合金、中间合金、铝挤压产品、来料加工装配及相关材料的研发、生产、销售及以上产品相关废料的回收、销售。",
        addr: "山东省聊城市茌平县信发街道信发路1号",phone: "",zitype: 3},
        {right: 120,top: 286,name: "扬州",type: 2,nameAll: "扬州瑞斯乐复合金属材料有限公司",desc: "云海金属集团全资子公司，专业生产微通道扁管和高性能铝棒。",
        addr: "江苏省扬州市高邮市经济开发区波司登大道12号",phone: "0514-84693169"},
        {right: 140,top: 310,isZongbu: true,name: "南京总部",nameAll: "云海金属集团",desc: "集团总部，主营铝合金锭、铝合金棒材等产品生产制作。",
        addr: "江苏省南京市溧水区东屏街道开屏路11号",phone: "025-57234888",child: [
          {nameAll: "南京云海轻金属精密制造有限公司",desc: "云海金属集团全资子公司，主营镁、铝合金产品的压铸和精加工。",
          addr: "江苏省南京市溧水区洪蓝镇金牛南路600号",phone: "025-57234888"},
          {nameAll: "南京云开合金有限公司",desc: "云海金属集团全资子公司，主营镁合金、铝合金、中间合金产品及相关材料的研发、生产、销售。",
          addr: "江苏省南京市溧水区晶桥镇云海路2号",phone: "025-57234888"},
          {nameAll: "南京云海金属贸易有限公司",desc: "负责集团各分公司产品的国外销售及进出口工作。",
          addr: "江苏省南京市溧水区东屏街道开屏路11号",phone: "025-57234888"},
        ]},
        {right: 312,top: 355,name: "重庆",nameAll: "重庆博奥镁铝金属制造有限公司",desc: "云海金属集团全资子公司，主要生产汽车部件和电动工具，包括CCB、中控支架、座椅骨架、PCF、显示器支架、齿轮箱、锯盘壳体等。",
        addr: "重庆市万盛经开区南桐镇平山大道5号",phone: ""},
        {right: 226,top: 340,name: "荆州",nameAll: "荆州云海精密制造有限公司",desc: "云海金属集团全资子公司，主要从事镁合金、铝合金产品的压铸制造以及精密加工。",
        addr: "湖北省荆州经济开发区曙光路西端",phone: "0716-4312686-7007"},
        {right: 175,top: 404,name: "惠州",nameAll: "惠州云海镁业有限公司",desc: "云海金属集团全资子公司，主要从事镁合金产品的生产。",
        addr: "广东省惠州市博罗县泰美镇板桥工业园区",phone: "0752-6723839"},
        {right: 200,top: 377,name: "池州",type: 3,nameAll: "安徽宝镁轻合金有限公司",desc: "云海金属集团参股子公司，主营镁基轻合金及其深加工产品。",
        addr: "安徽省池州市青阳县童埠新区",phone: "",zitype: 3},
        {right: 165,top: 355,name: "巢湖",type: 3,nameAll: "巢湖云海镁业有限公司",desc: "云海金属集团全资子公司，主要生产白云石、镁合金粒子和镁合金铸锭，产品广泛应用于汽车及电子3C行业。",
        addr: "安徽省巢湖市居巢区夏阁镇工业集中区",phone: "0565-8364640",child: [
          {nameAll: "安徽云海铝业有限公司",desc: "云海金属集团全资子公司，年产15万吨轻量化铝挤压型材，配套20万吨高性能铝棒。型材主要应用在新能源车和传统汽车轻量化产品，如保险杠、防撞梁、吸能盒、电池托架、控制臂、转向节支架等。",
          addr: "安徽省合肥市巢湖市安徽居巢经开区夏阁园区朝阳山路与云华大道交叉口西南侧",phone: "",zitype: 1},
          {nameAll: "巢湖云海轻金属精密制造有限公司",desc: "云海金属集团全资子公司，年产1500万只方向盘骨架、300万前叉及100万方建筑模板，该项目以其特有的镁水直供技术与单元岛自动化集成技术，为公司数字化生产打下基础，旨在打造业内一流高效的数智化工厂。",
          addr: "安徽省合肥市巢湖市安徽居巢经济开发区夏阁园区云华大道与万家山路交叉口",phone: "",zitype: 1},
          {nameAll: "安徽镁铝建筑模板科技有限公司",desc: "云海金属集团与南京领航云筑新材料科技有限公司共同成立，持续开展轻型建筑模板的研发、设计、生产、成套、安装、服务、回收和标准化的研发创新，围绕“轻、快、好、省”的核心价值，为广大客户提供轻松、绿色建造的系统解决方案。",
          addr: "安徽省合肥市巢湖市安徽居巢经济开发区夏阁园区云华大道与万家山路交叉口",phone: "",zitype: 3},
          {nameAll: "宜安云海科技有限公司",desc: "云海金属集团与东莞宜安科技股份有限公司共同出资成立，主要生产汽车、航天、轨道交通零部件和消费电子的镁铝合金精密压铸件。",
          addr: "安徽省巢湖市居巢区夏阁镇竹下路",phone: "0551-82282777",zitype: 3},
        ]},
        {right: 175,top: 439,name: "香港",type: 4,nameAll: "瑞宝金属(香港)有限公司",desc: "负责集团各分公司产品的国外销售及进出口工作。",
        addr: "香港上环永乐街148号南和行大厦1905室",phone: "025-57234888"},
        {right: 170,top: 205,name: "天津",type: 4,nameAll: "天津六合镁制品有限公司",desc: "云海金属集团全资子公司，致力于高品质镁、铝合金汽车方向盘骨架、安全带芯轴、机械式手刹支架、座椅扶手支架、电动自行车轮毂、罩盖、车架以及其它汽车用、民用零部件的制造。",
        addr: "天津经济技术开发区黄海路268号",phone: "022-59816486"},
      ],
    },
    // 联系我们
    contact: {
      title: "集团总部",
      addr: "地址：江苏省南京市溧水区东屏街道开屏路11号",
      email: "企业邮箱：info@rsm.com.cn",
      chuan: "传真：+86-25-57234168",
      phone: "联系方式：+86-25-57234888",
      title2: "业务联系",
      company: "公司",
      addr2: "地址",
      lists: [
        {title: "镁合金",lists: [
          {name: "张正文",phone: "15195690580",email: "zhangzw@rsm.com.cn",company: "巢湖云海镁业有限公司",addr: "安徽省巢湖市居巢区夏阁镇工业集中区"},
          {name: "顾鑫",phone: "18061270089",email: "gux@rsm.com.cn",company: "五台云海镁业有限公司",addr: "山西省忻州市五台县工业园"},
          {name: "黄修锐",phone: "19951780227",email: "huangxr@rsm.com.cn",company: "惠州云海镁业有限公司",addr: "广东省惠州市博罗县泰美镇板桥工业园区"},
        ]},
        {title: "铝合金棒、锭",lists: [
          // {name: "刘敏",phone: "18061288830",email: "lium@rsm.com.cn",company: "南京云海特种金属股份有限公司",addr: "江苏省南京市溧水区东屏街道开屏路11号"},
          // {name: "陈智",phone: "13770908885",email: "chenz@rsm.com.cn",company: "南京云海特种金属股份有限公司",addr: "江苏省南京市溧水区东屏街道开屏路11号"},
          {name: "余平范",phone: "18952087890",email: "yupf@rsm.com.cn",company: "南京云海特种金属股份有限公司",addr: "江苏省南京市溧水区东屏街道开屏路11号"},
        ]},
        {title: "中间合金",lists: [
          {name: "张金波",phone: "13401956464",email: "zhangjb@rsm.com.cn",company: "南京云开金属有限公司",addr: "江苏省南京市溧水区晶桥镇云海路2号"},
        ]},
        {title: "金属锶",lists: [
          {name: "顾鑫",phone: "18061270089",email: "gux@rsm.com.cn",company: "五台云海镁业有限公司",addr: "山西省忻州市五台县工业园"},
        ]},
        {title: "压铸",lists: [
          {name: "张磊",phone: "15050565757",email: "zhangl@rsm.com.cn",company: "南京云海轻金属精密制造有限公司",addr: "江苏省南京市溧水区洪蓝镇金牛南路600号"},
          {name: "周楫",phone: "15902347235",email: "ji.zhou@boao-mag.com",company: "重庆博奥镁铝金属制造有限公司",addr: "重庆市万盛经开区南桐镇平山大道5号"},
          {name: "卢斌",phone: "13821823297",email: "lubin@rsm.com.cn",company: "天津六合镁制品有限公司",addr: "天津经济技术开发区黄海路268号"},
        ]},
        {title: "多孔微通道扁管",lists: [
          {name: "王超",phone: "18136628509",email: "wcgy@rsm.com.cn",company: "扬州瑞斯乐复合金属材料有限公司",addr: "江苏省扬州市高邮市经济开发区波司登大道12号"},
          {name: "李勇",phone: "18118211011",email: "liyong@rsm.com.cn",company: "扬州瑞斯乐复合金属材料有限公司",addr: "江苏省扬州市高邮市经济开发区波司登大道12号"},
        ]},
        {title: "工业用铝挤压材料、板材、型材",lists: [
          {name: "原迎春",phone: "18061691330",email: "yuanlc@rsm.com.cn",company: "南京云海特种金属股份有限公司",addr: "江苏省南京市溧水区东屏街道开屏路11号"},
          // {name: "黄修锐",phone: "19951780227",email: "huangxr@rsm.com.cn",company: "南京云海特种金属股份有限公司",addr: "江苏省南京市溧水区东屏街道开屏路11号"},
          {name: "刘敏",phone: "18061288830",email: "lium@rsm.com.cn",company: "南京云海特种金属股份有限公司",addr: "江苏省南京市溧水区东屏街道开屏路11号"},
        ]},
        {title: "海外销售",lists: [
          {name: "吴凡",phone: "13801597349",email: "wuf@rsm.com.cn",company: "瑞宝金属（香港）有限公司",addr: "江苏省南京市溧水区东屏街道开屏路11号"},
        ]},
      ],
    },
    // 媒体中心
    media: {
      lists: {title: "媒体中心",child: [{name: "企业新闻"},{name: "贸易预警",child: [{name: "预警信息"},{name: "预警分析"},{name: "工作动态"}]}]},// 左侧导航内容列表
      more: "加载更多···",
      all: "全部内容加载完毕",
    },
    // 产品中心
    product: {
      title: "产品中心",
      contact: "联系我们",
      pre: "上一页",
      next: "下一页",
    },
  },
  // 英文
  2: {
    // 顶部内容
    top: {
      // 导航
      navs: [
        {path: "index",name: "HOME"},
        {path: "about",name: "US",name2: "About Us",children: []},
        {path: "product",name: "PRODUCT",name2: "Product Center",children: []},
        {path: "media",name: "NEWS",name2: "News Center"},
        {path: "contact",name: "CONTACT",name2: "Contact Us"}
      ],
    },
    // 底部内容
    foot: {
      // 导航
      navs: [
        {path: "about",name: "About",children: [{name: "Introduction"},{name: "Course"},{name: "Distribution"}]},
        {path: "media",name: "News",children: [{name: "Company News"},{name: "Trade Warning"}]},
        {path: "product",name: "Product",children: [{name: "Metal"},{name: "Ore"},{name: "Die Casting"},{name: "Exrrusion"}]},
        {path: "contact",name: "Contact",name2: "Contact Us"},
      ],
      // 地址
      addr: "Group Headquarters Address：No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province, China",
    },
    // 首页
    index: {
      // 公司描述
      describe: [
        "RSM Group was established in 1993 and listed on the Shenzhen Stock Exchange in 2007.",
        "After more than 20 years of development, the company has become a high-tech enterprise integrating mining, non-ferrous metal smelting, recycling and processing.",
        "The group has more than 10 subsidiaries across the country, and its products are widely used in automobile, 3C electronics, aerospace and other fields."
      ],
      // 按钮
      btn1: "About Us",
      btn2: "News",
      btn3: "Product",
    },
    // 关于我们
    about: {
      lists: {title: "ABOUT",child: [{name: "Introduction"},{name: "Course"},{name: "Distribution"}]},
      title: "RSM Group",
      title2: "Global leader in the field of light metal materials",
      describe: [
        'RSM Group was established in 1993 and listed on the Shenzhen Stock Exchange in 2007. After 30 years of development, the company has become a high-tech enterprise integrating mining, non-ferrous metal smelting, processing and recycling. The group has more than 10 subsidiaries around the world whose products are widely used in automotive and aerospace industry, electronics, etc.',
        'As a global leader in light metal materials, RSM Group has a complete chain of research, development and manufacture, and its market shares of major products such as magnesium, aluminum, and strontium lead the way around the world. In recent years, with its solid experience in dealing with raw materials, RSM group has proactively expanded to the downstream part of lightweight components, forming a complete magnesium industrial chain of "Dolomite Mining-Crude Magnesium Smelting-Magnesium Alloy Smelting-Magnesium Alloy Processing-Magnesium Alloy Recycling" and featured product line of "Quality aluminum alloy-aluminum extrusion processing".',
        'Looking to the future, RSM Group insists on innovation, internationalization, and green and sustainable development, striving to build a "high-tech and efficient lightweight industry group" to provide high-quality products and services for the development of lightweight industries in China and around the globe.',
      ],
      title3: "The development course",
      title4: "More than 20 years of <br> continuous accumulation and exploration",
      title5: "Company distribution",
      title6: "More than 10 subsidiaries nationwide and overseas",
      desc: "Introduction",
      addr: "Address",
      phone: "Phone",
      zong: "Controlling company",
      fen1: "Wholly-owned subsidiaries",
      fen2: "Joint Ventures",
      dataList: [
        {right: 198,top: 220,name: "Wutai",nameAll: "Wutai Yunhai Magnesium Industry Co., Ltd",desc: "A wholly-owned subsidiary of RSM Group, it mainly produces magnesium alloy and strontium metal.",
        addr: "Industrial Park, Wutai County, Xinzhou, Shanxi Province",phone: "0350-3357550"},
        {right: 155,top: 250,name: "Yunxin",nameAll: "Shandong Yunxin Aluminum Technology Co., Ltd.",desc: "RSM Group and Xinfa Group Co., Ltd. were jointly established as a joint venture. The main business scope includes aluminum alloy, master alloy, aluminum extrusion products, processing and assembly with supplied materials, and related materials’ research and development, production, sales, and the recycling and sales of scraps of the above products. ",
        addr: "No. 1 Xinfa Road, Xinfa Street, Chiping County, Liaocheng, Shandong Province",phone: "",zitype: 3},
        {right: 120,top: 286,name: "Yangzhou",type: 2,nameAll: "Yangzhou Ruisile Composite Metal Material Co., Ltd",desc: "A wholly-owned subsidiary of RSM Group, it specializes in the production of microchannel flat tubes.",
        addr: "No. 12  Bosideng Avenue, Gaoyou Economic Development Zone, Yangzhou, Jiangsu Province",phone: "0514-84693169"},
        {right: 140,top: 310,isZongbu: true,name: "RSM Group",nameAll: "RSM Group",desc: " The headquarters of the group is mainly engaged in the production of aluminum alloy ingots and aluminum alloy bars.",
        addr: "No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province, China",phone: "025-57234888",child: [
          {nameAll: "Nanjing Yunhai Light Metal Precision Manufacture Co., Ltd.",desc: "A wholly-owned subsidiary of RSM Group, it is mainly engaged in die-casting and finishing of magnesium and aluminum alloy products.",
          addr: "No. 600  Jinniu South Road, Honglan Town, Lishui District, Nanjing, Jiangsu Province",phone: "025-57234888"},
          {nameAll: "Nanjing YKB Co., Ltd.",desc: "A wholly-owned subsidiary of RSM Group, it is mainly engaged in the research and development, production and sales of magnesium alloy, aluminum alloy, master alloy products and related materials.",
          addr: "No. 2 Yunhai Road, Jingqiao Town, Lishui District, Nanjing, Jiangsu Province",phone: "025-57234888"},
          {nameAll: "Nanjing Welbow Metals Co., Ltd.",desc: "Responsible for the sales, import and export trade of products of all the subsidiaries.",
          addr: "No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province, China",phone: "025-57234888"},
        ]},
        {right: 312,top: 355,name: "Chongqing",nameAll: "Chongqing Boao Magnesium Aluminum Metal Manufacture Co., Ltd",desc: " A wholly-owned subsidiary of RSM Group, it mainly produces auto parts and electric tools, including CCB, central control bracket, seat frame, PCF, display bracket, gear box, saw disk housing, etc.",
        addr: "No. 5 Pingshan Avenue, Nantong Town, Wansheng Economic Development Zone, Chongqing",phone: ""},
        {right: 226,top: 340,name: "Jingzhou",nameAll: "Jingzhou Yunhai Precision Manufacture Company",desc: "A wholly-owned subsidiary of RSM Group, it is mainly engaged in die-casting manufacturing and precision machining of magnesium alloy and aluminum alloy products.",
        addr: "West End of Shuguang Road, Jingzhou Economic Development Zone, Hubei Province",phone: "0716-4312686-7007"},
        {right: 175,top: 404,name: "Huizhou",nameAll: "Huizhou Yunhai Magnesium Industry Co., Ltd",desc: "A wholly-owned subsidiary of RSM Group, it is mainly engaged in the production of magnesium alloy products.",
        addr: "Banqiao Industrial Park, Taimei Town, Boluo County, Huizhou, Guangdong Province",phone: "0752-6723839"},
        {right: 200,top: 377,name: "Chizhou",type: 3,nameAll: "Anhui Baomei Light Alloy Co., Ltd",desc: "RSM Group’s share-holding subsidiary company, it is mainly engaged in magnesium-based light alloy and its deep-processed products.",
        addr: "Tongbu New District, Qingyang County, Chizhou, Anhui Province",phone: "",zitype: 3},
        {right: 165,top: 355,name: "Chaohu",type: 3,nameAll: "Chaohu Yunhai Magnesium Industry Co., Ltd",desc: "A wholly-owned subsidiary of RSM Group, it mainly produces dolomite, magnesium alloy particles/chips and magnesium alloy ingots, which are widely used in the automotive and 3C electronic  industries.",
        addr: "Industrial Zone, Xiage Town, Juchao District, Chaohu, Anhui Province",phone: "0565-8364640",child: [
          {nameAll: "Anhui Yunhai Aluminum Co., Ltd.",desc: "A wholly-owned subsidiary of RSM Group, with an annual output of 150,000 tons of lightweight aluminum extrusion profiles, supporting 200,000 tons of high-performance aluminum bars. Profiles are mainly used in new energy vehicles and traditional automotive lightweight products, such as bumpers, anti-collision beams, energy-absorbing boxes, battery brackets, control arms, steering knuckle brackets, etc.",
          addr: "Southwest of the intersection of Chaoyangshan Road and Yunhua Avenue, Xiage Park, Anhui Juchao Economic Development Zone, Chaohu City, Hefei City, Anhui Province",phone: "",zitype: 1},
          {nameAll: "Chaohu Yunhai Light Metal Precision Manufacturing Co., Ltd.",desc: "Introduction: A wholly-owned subsidiary of RSM Group, an annual output of 15 million steering wheel skeletons, 3 million front forks and 1 million square building templates. With its unique liquid magnesium supply technology and unit island automation integration technology, this project lays the foundation for the company's digital production, aiming to build a first-class and efficient digital and intelligent chemical factory in the industry.",
          addr: "Intersection of Yunhua Avenue and Wanjiashan Road, Xiage Park, Anhui Juchao Economic Development Zone, Chaohu City, Hefei City, Anhui Province",phone: "",zitype: 1},
          {nameAll: "Anhui Magnesium Aluminum Building Formwork Technology Co., Ltd.",desc: 'RSM Group and Nanjing Linghang Yunzhu New Material Technology Co., Ltd. were jointly established to continue to carry out research and development, design, production, complete sets, installation, service, recycling and standardization of light building formwork. Focusing on the core values of "light, fast, good, and economical", we provide customers with system solutions for easy and green construction.',
          addr: "Intersection of Yunhua Avenue and Wanjiashan Road, Xiage Park, Anhui Juchao Economic Development Zone, Chaohu City, Hefei City, Anhui Province",phone: "",zitype: 3},
          {nameAll: "Yian Yunhai Technology Co., Ltd.",desc: "Jointly funded and established by RSM Group and Dongguan Yian Technology Co., Ltd., it mainly produces magnesium-aluminum alloy precision die castings for automobiles, aerospace, rail transit parts and consumer electronics.",
          addr: "Zhuxia Road, Xiage Town, Juchao District, Chaohu, Anhui Province",phone: "0551-82282777",zitype: 3},
        ]},
        {right: 175,top: 439,name: "Hong Kong",type: 4,nameAll: "WELBOW METALS（HONGKONG）CO.,LTD.",desc: "Responsible for the sales, import and export trade of products of all the subsidiaries.",
        addr: "Room 1905, Nam Wo Hong Building, 148 Wing Lok Street, Sheung Wan, Hong Kong",phone: "025-57234888"},
        {right: 170,top: 205,name: "TianJin",type: 4,nameAll: "TianJin Liuhe Magnesium Product Co.,Ltd.",desc: "A wholly-owned subsidiary of RSM Group, dedicated to high-quality magnesium and aluminum alloy car steering wheel frames, seat belt mandrels, mechanical handbrake brackets, seat armrest brackets, electric bicycle wheels, covers, frames, and other automotive and civilian use  manufacturing of parts.",
        addr: "268 Huanghai Road, Tianjin Economic and Technological Development Zone.",phone: "022-59816486"},
      ],
    },
    // 联系我们
    contact: {
      title: "Group headquarters",
      addr: "Group Headquarters’ Address：No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province, China",
      email: "Enterprise email：info@rsm.com.cn",
      chuan: "Fax：+86-25-57234168",
      phone: "Tel：+86-25-57234888",
      title2: "Business Contacts",
      company: "Company",
      addr2: "Address",
      lists: [
        {title: "Magnesium Alloy",lists: [
          {name: "Zhengwen Zhang",phone: "15195690580",email: "zhangzw@rsm.com.cn",company: "Chaohu Yunhai Magnesium Industry Co., Ltd.",addr: "Industrial Zone, Xiage Town, Juchao District, Chaohu, Anhui Province"},
          {name: "Xin Gu",phone: "18061270089",email: "gux@rsm.com.cn",company: "Wutai Yunhai Magnesium Industry Co., Ltd.",addr: "Industrial Park, Wutai County, Xinzhou, Shanxi Province"},
          {name: "Alex Huang",phone: "19951780227",email: "huangxr@rsm.com.cn",company: "Huizhou Yunhai Magnesium Industry Co., Ltd.",addr: "Banqiao Industrial Park, Taimei Town, Boluo County, Huizhou, Guangdong Province"},
        ]},
        {title: "Aluminum Alloy Rod& Ingot",lists: [
          {name: "Pingfan Yu",phone: "18952087890",email: "yupf@rsm.com.cn",company: "RSM Group",addr: "No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province"},
          // {name: "Liumin",phone: "18061288830",email: "lium@rsm.com.cn",company: "RSM Group",addr: "No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province"},
          // {name: "Chenzhi",phone: "13770908885",email: "chenz@rsm.com.cn",company: "RSM Group",addr: "No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province"},
        ]},
        {title: "Aluminum Master Alloys",lists: [
          {name: "Jingbo Zhang",phone: "13401956464",email: " zhangjb@rsm.com.cn",company: "RSM Group",addr: "No. 2 Yunhai Road, Jingqiao Town, Lishui District, Nanjing, Jiangsu Province"},
        ]},
        {title: "Strontium Metal",lists: [
          {name: "Xin Gu",phone: "18061270089",email: "gux@rsm.com.cn",company: "Wutai Yunhai Magnesium Industry Co., Ltd.",addr: "Industrial Park, Wutai County, Xinzhou, Shanxi Province"},
        ]},
        {title: "Die Casting",lists: [
          {name: "Nick Zhang",phone: "15050565757",email: "zhangl@rsm.com.cn",company: "Nanjing Yunhai Light Metal Precision Manufacture Co., Ltd.",addr: "No. 600 Jinniu South Road, Honglan Town, Lishui District, Nanjing, Jiangsu Province"},
          {name: "Zac Zhou",phone: "15902347235",email: "ji.zhou@boao-mag.com",company: "Chongqing Boao Magnesium Aluminum Metal Manufacture Co., Ltd.",addr: "No. 5 Pingshan Avenue, Nantong Town, Wansheng Economic Development Zone, Chongqing"},
          {name: "Bin Lu",phone: "13821823297",email: "lubin@rsm.com.cn",company: "Tianjin Liuhe Magnesium Product Co., Ltd.",addr: "No.268 Huanghai Road, TEDA, Tianjin, P.R.C"},
        ]},
        {title: "Porous microchannel flat tubes",lists: [
          {name: "Chao Wang",phone: "18136628509",email: "wcgy@rsm.com.cn",company: "Yangzhou Ruisile Composite Metal Material Co., Ltd.",addr: "No. 12 Bosideng Avenue, Gaoyou Economic Development Zone, Yangzhou, Jiangsu Province"},
          {name: "Yong Li",phone: "18118211011",email: "liyong@rsm.com.cn",company: "Yangzhou Ruisile Composite Metal Material Co., Ltd.",addr: "No. 12 Bosideng Avenue, Gaoyou Economic Development Zone, Yangzhou, Jiangsu Province"},
        ]},
        {title: "Industrial aluminum extrusion materials, sheet materials and profiles",lists: [
          {name: "Yingchun Yuan",phone: "18061691330",email: "yuanlc@rsm.com.cn",company: "RSM Group",addr: "No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province"},
          // {name: "Alex Huang",phone: "19951780227",email: "huangxr@rsm.com.cn",company: " RSM Group",addr: "No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province"},
          {name: "Min Liu",phone: "18061288830",email: "lium@rsm.com.cn",company: "RSM Group",addr: "No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province"},
        ]},
        {title: "Global Business",lists: [
          {name: "Frank Wu",phone: "13801597349",email: "wuf@rsm.com.cn",company: "Nanjing Welbow Metals Co., Ltd/ WELBOW METALS（HONGKONG）CO.,LTD.",addr: "No.11 Kaiping Road, Dongping Sub-district, Lishui District, Nanjing, Jiangsu Province"},
        ]},
      ],
    },
    // 媒体中心
    media: {
      lists: {title: "NEWS",child: [{name: "Company news"}]},// 左侧导航内容列表
      more: "More···",
      all: "No More",
    },
    // 产品中心
    product: {
      title: "Product",
      contact: "Contact",
      pre: "Pre",
      next: "Next",
    },
  }
}

export default language;


// WEBPACK FOOTER //
// ./src/utils/language.js